import '@styles/pages/homepage.scss';

import { flickitySliderBySelector } from '@molecules/flickity-continuous-slider';
import { stickyCta } from '@organisms/sticky-cta';
import 'lite-youtube-embed';

stickyCta('.home-sticky', '.home-hero__ctas', 'home-sticky');
flickitySliderBySelector('.home-components-customers');
